import * as summaryApi from 'api/users/summary.api';

// Lazy import to break circular dependency chain through hours.actions
const getFetchHours = () => import('redux/modules/hours.actions').then(m => m.fetchHours);

import { clearSummaries } from 'redux/modules/summaries.types';
import { getIsDemoManagerPresetActive } from 'redux/modules/tic/tic.demo.selectors';
import { getFilterableUserIdsForList } from 'redux/modules/users-page/users-list/usersList.selectors';
import type {
  DetailsRef,
  Filter,
  Query,
} from 'redux/modules/users-page/users-list/usersList.types';
import * as actionTypes from 'redux/modules/users-page/users-list/usersList.types';
import { getAccountFeatures, getCurrentAccount } from 'redux/selectors/accounts';
import type { Thunk } from 'types/redux';
import type { DeepPartial } from 'types/utility';
import type { UsersSummaryQuery } from '../users-dashboard/usersDashboard.types';

export const setQuery = (query?: DeepPartial<Query>): Thunk => {
  return (dispatch, getState) => {
    const account = getCurrentAccount(getState());
    const startOfWeek = account.start_of_week;
    dispatch(actionTypes.setQuery({ query, startOfWeek }));
  };
};

export const setFilters = (filters: Partial<Filter>): Thunk => {
  return dispatch => {
    dispatch(actionTypes.setFilters(filters));
  };
};

export const resetQueryUsers = (): Thunk => {
  return (dispatch, getState) => {
    // Select all user ids that match the current users-page filter
    const userIdsForList = getFilterableUserIdsForList(getState());
    // this will update the all people list route:;
    dispatch(setQuery({ filters: { userIds: userIdsForList, teamIds: [] } }));
  };
};

export const getSummaryTotals = (
  params: Partial<Omit<UsersSummaryQuery, 'hasAccessToTasks'>> = {}
): Thunk => {
  return async (dispatch, getState) => {
    if (getIsDemoManagerPresetActive(getState())) {
      return;
    }
    const hasAccessToTasks = !!getAccountFeatures(getState()).tasks;
    const key = `${params.since}-${params.until}`;
    const totals = await summaryApi.getUsersSummaryTotals({
      ...params,
      hasAccessToTasks,
      userIds: params.userIds,
      teamIds: params.teamIds,
    });
    dispatch(actionTypes.fetchedTotals(totals, { key }));
  };
};

export const reloadSummaries = (): Thunk => {
  return dispatch => {
    dispatch(clearSummaries());
    dispatch(actionTypes.clearTotals());
  };
};

export const showDetails = (payload: DetailsRef): Thunk => {
  return (dispatch, getState) => {
    if (getIsDemoManagerPresetActive(getState())) {
      return;
    }
    const { date, userId } = payload;

    dispatch(actionTypes.showDetails(payload));
    return getFetchHours().then(fetchHours =>
      dispatch(
        fetchHours({
          since: date,
          upto: date,
          userId,
          userIds: null,
        })
      )
    );
  };
};

export const hideDetails = (): Thunk => (dispatch, getState) => {
  const state = getState();

  if (state.usersPage.list.control.shouldReload) {
    if (state.usersPage.list.control.detailsRef) {
      dispatch(reloadSummaries());
    }
  }

  dispatch(actionTypes.hideDetails());
};
